import {NgModule} from '@angular/core';
import {CalibrationLabelPipe} from './calibration-label/calibration-label.pipe';
import {ToRomanPipeModule} from './toRoman.module';
import {BytesFormatterPipe} from './bytes-formatter/bytes-formatter.pipe';

@NgModule({
    imports: [
        ToRomanPipeModule,
    ],
    declarations: [
        CalibrationLabelPipe,
        BytesFormatterPipe,
    ],
    exports: [
        CalibrationLabelPipe,
        BytesFormatterPipe,
        ToRomanPipeModule,
    ],
    providers: [
        CalibrationLabelPipe,
    ]
})
export class PipesModule {}
